/* eslint-disable import/prefer-default-export */

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { navigate } from 'gatsby';
import React, { useEffect, useState } from 'react';

import Store from './src/store';
import { isAccessTokenValid } from './src/api/login';

export const wrapRootElement = Store;

export const _redirectToLogin = () => {
  if (typeof window === 'undefined') return;

  const pathOrigin = window.location.origin;
  const isAuth = isAccessTokenValid();

  const currentApiUrl = new URL(process.env.GATSBY_API_URL);
  const currentApiUrlParts = currentApiUrl.hostname.split('.');
  const currentApiUrlPartsLength = currentApiUrlParts.length;
  const isOurDomain = pathOrigin.includes(`${currentApiUrlParts[currentApiUrlPartsLength - 2]}.${currentApiUrlParts[currentApiUrlPartsLength - 1]}`);

  const loader = document.getElementById('___loader');
  const loaderWhiteLabel = document.getElementById('___loader_white_label');
  const isWhiteLabel = document.getElementById('___white_label');

  if ((isWhiteLabel && isWhiteLabel.value && isWhiteLabel.value == 1) || (!isOurDomain && !isAuth)) {
    loaderWhiteLabel.style.display = 'flex';
    loaderWhiteLabel.style.zIndex = 10000;
  } else {
    loader.style.display = 'flex';
    loader.style.zIndex = 10000;
  }
};

export const onPreRouteUpdate = () => {
  _redirectToLogin();
}

export const onRouteUpdate = () => {
  document.getElementById('___loader').style.display = 'none';
  document.getElementById('___loader_white_label').style.display = 'none';
  document.body.style = null;
};